function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.15",
  d: "M3.375 6.75H.75m2.625 4.5H2.25M3.375 9H1.5m1.125 4.611A3.741 3.741 0 006 15.75h6A3.75 3.75 0 0015.75 12V6A3.75 3.75 0 0012 2.25H6a3.74 3.74 0 00-3.375 2.139M9 5.625v.75m0 6v-.75"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.15",
  d: "M7.394 10.687c.296.609.93.979 1.606.938a1.536 1.536 0 001.688-1.313v0c0-.567-.4-1.055-.957-1.166L8.27 8.854a1.19 1.19 0 01-.957-1.167v0A1.536 1.536 0 019 6.375a1.674 1.674 0 011.606.937"
}));